<template>
  <v-autocomplete
    :items="items"
    item-text="descricao"
    item-value="id"
    return-object
    v-bind="$attrs"
    v-bind:value="modelValue"
    v-on="inputListeners"
    :loading="loading"
  >
    <template #progress>
      <v-progress-linear
        style="position: absolute"
        height="2px"
        :color="cor_loading"
        indeterminate
      ></v-progress-linear>
    </template>

    <template #prepend-item v-if="!desativarSelecionarTodos && multiplaSelecao && items.length">
      <v-list-item
        v-if="modelValue.length === items.length"
        class="py-2"
        @click="updateModel([])"
      >
        <v-icon class="ml-2" color="primary">mdi-checkbox-marked</v-icon>
        <span class="ml-2 font-weight-medium">Desmarcar Todos</span>
      </v-list-item>

      <v-list-item
        v-else
        class="py-2"
      @click="updateModel(Helpers.arrayColumn(items, ['id', 'inicio', 'fim']))"
      >
        <v-icon v-if="modelValue.length > 0" class="ml-2" color="primary">mdi-minus-box</v-icon>
        <v-icon v-else class="ml-2">mdi-checkbox-blank-outline</v-icon>
        <span class="ml-2 font-weight-medium">Selecionar Todos</span>
      </v-list-item>

      <v-divider />
    </template>

    <template #selection="{item}" v-if="multiplaSelecao">
      <template v-if="modelValue.findIndex(i => i.id == item.id) < qtdeVisivelSelecionados">
        <span>{{item.descricao}}</span><template v-if="apendarVirgula(item)">,&nbsp;</template>
      </template>

      <template v-if="modelValue.findIndex(i => i.id == item.id) === qtdeVisivelSelecionados">
        <span class="ml-1 text-grat-900">(+ {{modelValue.length - qtdeVisivelSelecionados}})</span>
      </template>
    </template>

    <template v-for="(_, slot) of $scopedSlots" #[slot]="scope">
      <slot :name="slot" v-bind="scope"/>
    </template>

    <template #prepend-inner>
      <slot name="prepend-inner" />
    </template>
  </v-autocomplete>
</template>

<script>
export default {
  name: "SysHistogramaPersonalizadoAutocomplete",
  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },
  props: {
    modelValue: {
      type: [Number, String, Array],
      required: true
    },
    qtdeVisivelSelecionados: {
      type: [Number],
      default: 4
    },
    desativarSelecionarTodos: {
      type: Boolean,
      default: false
    },
    cor_loading: {
      type: String,
      default: 'red'
    },
    input_value: {
      type: Array
      // MODELO: [{ id: 1, inicio: 0, fim: 30, descricao: 'até 30 dias em aberto' }]
    }
  },
  data: () => ({
    items: [],
    loading: false,
    timer_buscar_items: null
  }),
  computed: {
    multiplaSelecao () {
      return ![null, undefined].includes(this.$attrs.multiple)
    },
    inputListeners: function () {
      const vm = this

      return Object.assign({},
        vm.$listeners, {
          input: function (values) {
            if ([null, undefined].includes(values)) {
              values = vm.$attrs.multiple ? [] : '';
            }

            vm.updateModel(values)
          }
        }
      )
    }
  },
  mounted() {
    this.items = this.input_value;
  },
  watch: {
    input_value(valor) {
      this.items = valor;
    }
  },
  methods: {
    verificaAtualizacaoFiltros(novo, antigo) {
      if (novo.length !== antigo.length) {
        clearTimeout(this.timer_buscar_items);
        this.timer_buscar_items = setTimeout(this.getItems, 2000);
      }
    },
    updateModel(values) {
      if ([null, undefined].includes(values)) {
        values = this.$attrs.multiple ? [] : '';
      }

      this.$emit('update:modelValue', values)
    },
    apendarVirgula (item) {
      const indexOf = this.modelValue.indexOf(item.id)
      return indexOf !== this.modelValue.length - 1 && indexOf < (this.qtdeVisivelSelecionados - 1)
    }
  }
}
</script>

<style scoped>
.pl-14px {
  padding-left: 14px
}
.text-grat-900 {
  color: #999;
}
</style>
